// index.tsx
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import React, { MouseEvent } from 'react'
import { GridColDef, GridInitialState } from '@mui/x-data-grid-pro'
import Table from '../Table'

/**
 * DrawerTable
 * A very small wrapper around table for drawers.
 */
export type DrawerTableProps = {
  /** The display width of the table */
  rows: Array<object>

  /** The number of rows to show */
  rowsToShow?: number

  /** The options for how many rows to show */
  rowsToShowOptions?: number[]

  /** The rows to display in the table */
  columns: GridColDef[]

  /** Enables a footer for this table, which can be used to add
   *  extra options for the table footer
   *  */
  footer?: boolean

  /** Displays a loading circle on top of the table */
  loading?: boolean

  /** Custom configuration to load this table with a initial state */
  initialState?: GridInitialState

  /**
   * Custom handler for the See All button
   */
  onSeeAllClick?: (e: MouseEvent) => void

  /**
   * The text to display on the See All button
   */
  seeAllText?: string
}

export function DrawerTable({
  rows,
  columns,
  footer,
  loading,
  initialState,
  onSeeAllClick,
  seeAllText = 'See All',
  rowsToShow,
  rowsToShowOptions
}: DrawerTableProps) {
  return (
    <Table
      width="100%"
      rows={rows}
      columns={columns}
      footer={footer}
      rowsToShow={rowsToShow}
      rowsToShowOptions={rowsToShowOptions}
      loading={loading}
      initialState={initialState}
      onSeeAllClick={onSeeAllClick}
      seeAllText={seeAllText}
      disableSelectionOnClick
      useGlobalPageSize={false}
    />
  )
}
DrawerTable.defaultProps = {
  footer: undefined,
  loading: false,
  initialState: undefined,
  onSeeAllClick: undefined,
  seeAllText: 'See All',
  rowsToShow: 5,
  rowsToShowOptions: [5]
}

export default DrawerTable
